'use client';

import Link from 'next/link';
import { useState } from 'react';

import {
  ONTARIO_DOG_OWNERS_LIABILITY_ACT_URL,
  ontarioPitBullBanStatus
} from '@paction-2.0/util/constants/breedLaws';

import { WarningTriangleIcon } from '@/components/icons';

import styles from './styles/ontarioBreedRestrictionBanner.module.scss';

export type OntarioBreedRestrictionBannerProps = {
  breedName: string;
  inOntario: boolean;
};

export function OntarioBreedRestrictionBanner({
  breedName,
  inOntario
}: OntarioBreedRestrictionBannerProps) {
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed || !ontarioPitBullBanStatus(breedName)) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <aside className={styles.banner} aria-label="Breed restrictions">
        <WarningTriangleIcon size={30} className={styles.icon} />
        <p className={styles.text}>
          There are restrictions for this breed{' '}
          {inOntario ? 'in your area' : 'in Ontario'}.{' '}
          <a
            href={ONTARIO_DOG_OWNERS_LIABILITY_ACT_URL}
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            Read more about the legislation here
          </a>{' '}
          or read more on Paction&apos;s{' '}
          <Link href="/expert-hub" className={styles.link}>
            Expert Hub
          </Link>
          .
        </p>
        <button
          type="button"
          className={styles.dismiss}
          onClick={() => setIsDismissed(true)}
          aria-label="Dismiss breed restrictions notice"
        >
          ×
        </button>
      </aside>
    </div>
  );
}
